import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import "./MessageCard.scss";
import { MessageType } from "constants/UserConstants";
import { BsCheckAll } from "react-icons/bs";
import TextMessageContent from "./TextMessageContent/TextMessageContent";
import ImageMessageContent from "./ImageMessageContent/ImageMessageContent";
import DocumentMessageContent from "./DocumentMessageContent/DocumentMessageContent";
import VideoMessageContent from "./VideoMessageContent/VideoMessageContent";
import AudioMessageContent from "./AudioMessageContent/AudioMessageContent";
import LocationMessageContent from "./LocationMessageContent/LocationMessageContent";
import { isAttachment } from "utils/Helpers";
import FormMessageContent from "./FormMessageContent/FormMessageContent";

export default function MessageCard(props) {
  const { messageSource, message, highlighted, isTransferred } = props;
  const highlightedClass = highlighted ? "highlighted" : "";
  const transferredClass = isTransferred & !highlighted ? "transferred" : "";

  const getCardContentAndCardClass = () => {
    if (isAttachment(message.messageType) && messageSource === "to") {
      return {
        cardContent: <DocumentMessageContent {...props} />,
        cardClass: "document-message",
      };
    }
    switch (message.messageType) {
      case MessageType.TEXT:
      case MessageType.BUTTON:
      case MessageType.WHATSAPP_TEMPLATE:
      case MessageType.WHATSAPP_LIST:
      case MessageType.TEXT_LIST_WITH_LINKS:
      case MessageType.INTERACTIVE_LIST_REPLY:
        return {
          cardContent: <TextMessageContent {...props} />,
          cardClass: "text-message",
        };
      case MessageType.CUSTOM:
        return {
          cardContent: <FormMessageContent {...props} />,
          cardClass: "custom-message",
        };
      case MessageType.IMAGE:
        return {
          cardContent: <ImageMessageContent {...props} />,
          cardClass: "image-message",
          showMessageCardTime: false,
        };
      case MessageType.DOCUMENT:
        return {
          cardContent: <DocumentMessageContent {...props} />,
          cardClass: "document-message",
        };
      case MessageType.VIDEO:
        return {
          cardContent: <VideoMessageContent {...props} />,
          cardClass: "video-message",
          showMessageCardTime: false,
        };
      case MessageType.AUDIO:
        return {
          cardContent: <AudioMessageContent {...props} />,
          cardClass: "audio-message",
        };
      case MessageType.VOICE:
        return {
          cardContent: <AudioMessageContent {...props} />,
          cardClass: "audio-message",
        };
      case MessageType.LOCATION:
        return {
          cardContent: <LocationMessageContent {...props} />,
          cardClass: "location-message",
        }
      default:
        return {
          cardContent: "",
          cardClass: "",
        };
    }
  };

  const renderMessageTime = (timestamp) => {
    return moment(timestamp).format("hh:mm A");
  };

  const {
    cardClass,
    cardContent,
    showMessageCardTime = true,
  } = getCardContentAndCardClass();

  return (
    <div
      className={`message-card ${cardClass} ${messageSource} ${transferredClass} ${highlightedClass}`}
      data-testid="message-card"
    >
      <div className="message-content">{cardContent}</div>
      <div className="message-time-and-receipt">
        {showMessageCardTime && (
          <div className="message-time">
            {renderMessageTime(message.messageTime)}
          </div>
        )}
        {message.deliveredAt && !message.seenAt && (
          <BsCheckAll
            size="1em"
            color="#656565"
            className="read-receipt delivered-at"
          />
        )}
        {message.deliveredAt && message.seenAt && (
          <BsCheckAll
            size="1em"
            color="#3A8AFA"
            className="read-receipt seen-at"
          />
        )}
      </div>
    </div>
  );
}

MessageCard.propTypes = {
  className: PropTypes.string,
  messageSource: PropTypes.oneOf(["from", "to"]),
  message: PropTypes.object.isRequired,
  highlighted: PropTypes.bool,
  isTransferred: PropTypes.bool,
};

MessageCard.defaultProps = {
  className: "",
  messageSource: "from",
  highlighted: false,
  isTransferred: false,
  file: "image",
};
